import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const TemplateGalleryLoader: LoadableType<{
	templatesPageSize?: number;
}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplateGallery" */ './TemplateGallery.tsx'))
			.TemplateGallery,
});
